<template>
  <div>
    <div class="bg-link h-9">
      <div v-for="(tab, index) in tabs" v-bind:key="index">
        <div class="float-left w-1/3 px-1 pt-1">
          <div class="text-center rounded-t-md font-bold pt-1 h-8" :class="index === selected ? 'selected' : 'bg-white'" @click="select(index)">
            {{ tab.label }}
          </div>
        </div>
      </div>
    </div>
    <div v-for="section in tabs[selected].sections" v-bind:key="section.caption" class="pt-1">
      <span class="bg-yellow-300 text-sm font-bold px-2 py-0.5" v-html="section.caption">
      </span>
      <div class="pt-2">
        <div class="overflow-x-scroll scrollbar">
          <ul class="whitespace-nowrap flex ml-2">
            <li v-for="item in section.items" v-bind:key="item.label" class="float-letf" @click="openUrl(item)">
              <div class="mr-2" :class="tabs[selected].size === 3 ? 'w-28' : 'w-44'">
                <div class="bg-white rounded-xl h-24 text-center">
                  <img :src="item.image" class="m-2 pt-2 w-20 m-auto max-h-24" :class="tabs[selected].size === 3 ? 'w-20' : 'w-32'"/>
                </div>
                <div class="text-center small_msg" v-html="item.label" v-bind:class="item.font">
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { event } from 'vue-gtag'

export default {
  data () {
    return {
      selected: 0,
      tabs:[{
        label: '移動する',
        size: 3,
        sections: [
          {
            caption: '<span class="material-symbols-outlined">pedal_bike</span><span class="material-symbols-outlined">directions_car</span><span class="ml-1">シェアサイクル・レンタカーを使う</span>',
            items:[
              {
                label: 'にいがた2km<br />シェアサイクル',
                image: require('@/assets/images/menu/niigata_cycle.jpg'),
                url: 'https://2km-cycle.niigata-city.com/'
              },
              {
                label: 'Ringo Pass',
                image: require('@/assets/images/menu/logo_jre.jpg'),
                url: 'https://ringopass.com/'
              },
              {
                label: '駅レンタカー',
                image: require('@/assets/images/menu/trenta_img.jpg'),
                url: 'https://www.jrerl.co.jp/'
              }
            ]
          },
          {
            caption: '<span class="material-symbols-outlined">directions_railway</span><span class="ml-1">電車・バスの位置情報を見る</span>',
            items:[
              {
                label: 'どこトレ',
                image: require('@/assets/images/menu/doko-train.jpg'),
                url: 'https://doko-train.jp/sp/index.html'
              },
              {
                label: 'にいがたバス乗換案内',
                image: require('@/assets/images/menu/niigata-kotsu.jpg'),
                url: 'https://transfer.navitime.biz/niigatabrt-newsystem/smart/top/Top'
              }
            ]
          }
        ]
      },
      {
        label: '楽しむ',
        size: 2,
        sections:[
          {
            caption: '<span class="material-symbols-outlined">local_dining</span><span class="ml-1">観光情報を見る</span>',
            items:[
              {
                label: '新潟市公式観光情報サイト',
                image: require('@/assets/images/menu/headerlogo.jpg'),
                url: 'https://www.nvcb.or.jp/'
              },
              {
                label: '新潟県公式観光情報サイト',
                image: require('@/assets/images/menu/logo_niigatakanko.jpg'),
                url: 'https://niigata-kankou.or.jp/'
              }
            ]
          },
          {
            caption: '<span class="material-symbols-outlined">box</span><span class="ml-1">おみやげをかう</span>',
            items:[
              {
                label: '【駅ビル】CoCoLo新潟',
                image: require('@/assets/images/menu/logo_footer_niigata.jpg'),
                url: 'https://jenic.jp/cocolo/?sc_name=niigata'
              },
              {
                label: '【通販】NIIGATA1〇〇',
                image: require('@/assets/images/menu/niigata100.jpg'),
                url: 'https://shopping.jreast.co.jp/shop/detail/S053'
              }
            ]
          }
        ]
      },
      {
        label: '手配する',
        size: 3,
        sections:[
          {
            caption: '<span class="material-symbols-outlined">tap_and_play</span><span class="ml-1">列車・シェアオフィスを予約する</span>',
            items:[
              {
                label: '【列車の予約】<br />えきねっと',
                image: require('@/assets/images/menu/logo_ekinet.jpg'),
                url: ' https://www.eki-net.com/'
              },
              {
                label: '【JR東日本のシェアオフィス】<br />STATION WORK',
                image: require('@/assets/images/menu/STATION_WORK.png'),
                url: 'https://www.stationwork.jp/'
              }
            ]
          },
          {
            caption: '<span class="material-symbols-outlined">kid_star</span><span class="ml-1">たびをさらにおトクに・便利に</span>',
            items:[
              {
                label: '【地域で使える電子チケット】<br />エキトマチケット',
                image: require('@/assets/images/menu/ekitoma.png'),
                url: 'https://www.jreastmall.com/shop/pages/ekitoma.aspx'
              },
              // {
              //   label: '【スマホひとつで便利で快適な旅】<br />Tabi-CONNECT',
              //   image: require('@/assets/images/menu/logo_mx.png'),
              //   url: 'https://maas-portal.com/'
              // },
              {
                label: '【スマホひとつで便利で快適な旅】<br />Niipass',
                image: require('@/assets/images/menu/logo_Niipass.jpg'),
                url: 'https://jpn01.safelinks.protection.outlook.com/?url=https%3A%2F%2Fmaas-portal.com%2Fniipass&data=05%7C02%7Ctsukasa-i%40jreast.co.jp%7Cffe34a3c44874ab9807208dce1ffb546%7Cb230699217184f1c8d81e650c06ad00c%7C1%7C0%7C638633735643356914%7CUnknown%7CTWFpbGZsb3d8eyJWIjoiMC4wLjAwMDAiLCJQIjoiV2luMzIiLCJBTiI6Ik1haWwiLCJXVCI6Mn0%3D%7C0%7C%7C%7C&sdata=ht2ybnl2EtWmKW0ALFQSQNdbJ528kZykD%2BnfSGvIL3M%3D&reserved=0'
              },
              {
                label: '佐渡版タクシー共同配車',
                image: require('@/assets/images/menu/sadotaxilogo.png'),
                url: 'https://campaign.nearme.jp/poc_sado'
              }
            ]
          }
        ]
      }]
    }
  },
  methods: {
    select: function (index) {
      this.selected = index
    },
    openUrl: function (item) {
      event(item.label)
      window.open(item.url, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.selected {
  background-color: #e8e8e8;
}
.small_msg{
  font-size: 0.5rem !important
}
</style>
